import React from 'react';
import { getFileUrl } from "../core/config/api.js";

const Avatar = ({user, fileId, onClick, fallback}) => {
    const id = fileId || (user && user.avatar_file_id)

    const defaultSrc = fallback
        || `/assets/${user?.gender || 'default'}-avatar.${user?.gender ? 'svg' : 'png'}`;

    const src = id ? getFileUrl(id) : defaultSrc;

    return (
        <>
            <img className="avatar" onClick={onClick} src={src} />
        </>
    )
};

export default Avatar;
